/**

Copyright (c) 2007 Matthew E. Foster

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/





$C = function (name, options){
	return Element.extend(Object.extend(document.createElement(name || "div"), options || {})); 
}


var EventDispatcher = function(){};
Object.extend(EventDispatcher.prototype, {
	buildListenerChain : function(){
		if(!this.listenerChain)
			this.listenerChain = {};							
	},
	addEventListener : function(type, listener){
		this.buildListenerChain();
		
		if(!this.listenerChain[type])					
			this.listenerChain[type] = [listener];
		else
			this.listenerChain[type].push(listener);
	},
	hasEventListener : function(type){
		return (typeof this.listenerChain[type] != "undefined");
	},
	removeEventListener : function(type, listener){
		if(!this.hasEventListener(type))
			return false;
			
		for(var i = 0; i < this.listenerChain[type].length; i++)
			if(this.listenerChain[type][i] == listener)
				this.listenerChain[type].splice(i, 1);
	},
	dispatchEvent : function(type, args){
		this.buildListenerChain();
		
		if(!this.hasEventListener(type))
			return false;
			
		this.listenerChain[type].any(function(f){ return (f(args) == false ? true : false); });
	}
});
				
				
var GridBase = function(){};
Object.extend(Object.extend(GridBase.prototype, EventDispatcher.prototype), {
	setTable : function(table){
		this.table = $(table);
	},
	getCell : function(row, cell){
		return this.table.down("tr", row).down("td", cell);
	},
	createListener : function(){
		this.createCellListener();
		this.createRowListener();
		this.createTableListener();
	},
	applyBehavior : function(){
		this.table.getElementsBySelector("td").forEach(this.attachCellListener.bind(this));
		this.table.getElementsBySelector("td").forEach(this.attachRowListener.bind(this));
		this.attachTableListener(this.table);			
	},
	createCellListener : function(){
		this.cellOverHandle = this.handleCellOver.bindAsEventListener(this);
		this.cellOutHandle = this.handleCellOut.bindAsEventListener(this);
		this.cellClickHandle = this.handleCellClick.bindAsEventListener(this);
		this.cellDownHandle = this.handleCellDown.bindAsEventListener(this);
		this.cellUpHandle = this.handleCellUp.bindAsEventListener(this);
	},
	createRowListener : function(){
		this.rowOverHandle = this.handleRowOver.bindAsEventListener(this);
		this.rowOutHandle = this.handleRowOut.bindAsEventListener(this);
	},
	createTableListener : function(){
		this.tableOverHandle = this.handleTableOver.bindAsEventListener(this);
		this.tableOutHandle = this.handleTableOut.bindAsEventListener(this);
		this.tableDownHandle = this.handleTableDown.bindAsEventListener(this);
		this.tableUpHandle	= this.handleTableUp.bindAsEventListener(this);				
	},
	attachCellListener : function(cell){
		Event.observe(cell, "click", this.cellClickHandle);
		Event.observe(cell, "mouseover", this.cellOverHandle);
		Event.observe(cell, "mouseout", this.cellOutHandle);
	},
	attachRowListener : function(row){
		Event.observe(row, "mouseover", this.rowOverHandle);
		Event.observe(row, "mouseout", this.rowOutHandle);
	},
	attachTableListener : function(table){
		Event.observe(table, "mouseover", this.tableOverHandle);
		Event.observe(table, "mouseout", this.tableOutHandle);
		Event.observe(table, "mousedown", this.tableDownHandle);
		Event.observe(table, "mouseup", this.tableUpHandle);
	},
	handleCellOver : function(e){
		this.dispatchEvent("cellover", e);
		if(this.mouseDown == true)
			this.dispatchEvent("celldown", e);
	},
	handleCellOut : function(e){
		this.dispatchEvent("cellout", e);
	},
	handleCellUp : function(e){
		this.dispatchEvent("cellup", e);
	},
	handleCellDown : function(e){
		this.dispatchEvent("celldown", e);
	},
	handleCellClick : function(e){
		this.dispatchEvent("cellclick", e);
	},
	handleRowOver : function(e){
		this.dispatchEvent("rowover", e);
	},
	handleRowOut : function(e){
		this.dispatchEvent("rowout", e);
	},
	handleTableOver : function(e){
		this.dispatchEvent("tableover", e);						
	},
	handleTableOut : function(e){
		this.dispatchEvent("tableout", e);
	},
	handleTableDown : function(e){
		this.mouseDown = true;
		this.dispatchEvent("tabledown", e);
	},
	handleTableUp : function(e){
		this.mouseDown = false;
		this.dispatchEvent("tableup", e);
	}
});


var GridBuild = function(){};
Object.extend(Object.extend(GridBuild.prototype, GridBase.prototype), {
	buildGrid : function(columns, rows, showWeekNumber){
		let table = document.createElement('table');
		table.classList.add('widget', 'calendar');

		let tbody = document.createElement('tbody');

		for (let r = 0; r < rows; r++) {
			let row = document.createElement('tr');
			
			if (showWeekNumber) {
				let week = document.createElement('td');
				week.classList.add('week');
				row.appendChild(week);
			}
			
			for (let c = 0; c < columns; c++) {
				let td = document.createElement('td');
				td.classList.add('empty');
				row.appendChild(td);
			}

			tbody.appendChild(row);
		}

		table.appendChild(tbody);
		return table;
	},	

	applyCalendarDays : function(days){
		days.forEach(this.iterateRow.bind(this));
	},
	iterateRow : function(rowArr, itr){
		if (this.options.showWeekNumber) {
			var weekdate = rowArr.filter(i => i)[0];
			var cell = this.getCell(itr, -1);
			var contents = moment(weekdate).startOf('week').isoWeek();
			
			if (this.options.showEvenOdd) {
				var repeat = (Math.floor((moment(weekdate).startOf('week').subtract(1, 'days').unix()) / (7 * 24 * 3600)) % 2) + 1;
				cell.classList.add(repeat != 1 ? 'even' : 'odd');
			}
			
			cell.update(contents);
		}
		
		rowArr.forEach(this.applyDayToCell.bind(this, itr));
	},
	applyDayToCell : function(row, obj, cell) {
	}
});



var CalendarSelect = Class.create();
Object.extend(Object.extend(CalendarSelect.prototype, GridBuild.prototype), {
	initialize : function(container, options){
		this.options = Object.extend({ 
			weekLength : 7, 
			endWeek : 0, 
			showWeekNumber : false, 
			showControls: true, 
			showYearNavigation: false, 
			showActive: true,
			date: moment(),
			active: moment(), 
			enabled: true, 
			minDate: null, 
			maxDate: null 
		}, options || {});
		
		var container = $(container);

		this.container = document.createElement('div');
		container.appendChild(this.container);
		
		this.active = null;
		this.current = this.options.date ? moment(this.options.date).startOf('month') : moment().startOf('month');
	
		this.calendarDays = this.buildCalendarDays(this.current);
		this.createTable(this.calendarDays.length);
		
		this.createListener();
		this.applyBehavior();
		
		this.applyCalendarDays(this.calendarDays);
	},
	getCell : function(row, cell){
		cell = this.options.showWeekNumber ? cell + 1 : cell;
		return this.table.tBodies[0].childNodes[row].childNodes[cell];
	},
	createListener : function(){ 
		GridBuild.prototype.createListener.apply(this, arguments);
	
		this.dayClickHandle = this.handleDayClick.bindAsEventListener(this);
	},							
	createTable : function(weeks){
		var table = this.buildGrid(this.options.weekLength, weeks, this.options.showWeekNumber);
		this.container.appendChild(table);
		this.setTable(table);
	},
	applyDayToCell : function(row, current, cell) {
		var cellNode = this.getCell(row, cell);
		
		if(!(cellNode && current)) {
			return false;
		}
			
		Event.observe(cellNode, "click", this.dayClickHandle);
		Event.observe(cellNode, "keypress", this.dayClickHandle);

		cellNode.classList.remove('empty');
		cellNode.tabIndex = 0;
		cellNode.innerText = current.date();
		cellNode.dataset.date = current.format('YYYY-MM-DD');
		
		if (this.options.individualCallback) {
			this.options.individualCallback(current.toDate(), cellNode);
		}
		
		if (current.isSame(moment(), 'day')) {
			cellNode.classList.add('today');
		}

		if (this.options.active) {
			if (this.options.active instanceof Array) {
				if (current.isSameOrAfter(moment(this.options.active[0]), 'day') && current.isSameOrBefore(moment(this.options.active[1]), 'day')) {
					if (this.options.showActive) cellNode.classList.add('active');	
					
					if (this.active instanceof Array) {
						this.active.push(cellNode);
					} else {
						this.active = [ cellNode ];
					}
				}
			}
			else {
				if (current.isSame(moment(this.options.active), 'day')) {
					if (this.options.showActive) cellNode.classList.add('active');	
					this.active = [ cellNode ];
				}
			}
		}
		
		if (this.options.maxDate) {
			if (current.isAfter(moment(this.options.maxDate), 'day')) {
				cellNode.classList.add('disabled');	
			}
		}
		
		if (this.options.minDate) {
			if (current.isSameOrBefore(moment(this.options.minDate), 'day')) {
				cellNode.classList.add('disabled');	
			}
		}
		
		if (!this.options.enabled) {
			cellNode.classList.add('disabled');	
		}
	},
	buildCalendarDays : function(range){
		let current = moment(range);

		let month = [];
		let week = new Array((current.day() + 6) % 7);

		let days = current.daysInMonth();
		while (days) {
			week.push(current.clone())

			if (current.day() == this.options.endWeek) {
				month.push(week);
				week = [];
			}

			current.add(1, 'days');
			days--;
		}

		if (week.length > 0) {
			month.push(week);
		}
		
		return month;
	},			

	handleDayClick : function(e) {
		if (e.type == 'keypress' && e.key != 'Enter') return;

		if (Event.element(e).classList.contains('disabled')) {
			return;
		}
		
		this.dispatchEvent("dayclick", moment(Event.element(e).dataset.date, 'YYYY-MM-DD').toDate());
	}
});



var DateSelect = Class.create();
Object.extend(Object.extend(DateSelect.prototype, CalendarSelect.prototype), {
	initialize: function(container, options){
		this.options = options;
		
		CalendarSelect.prototype.initialize.apply(this, arguments);

		this.createListener();
		
		this.header = this.createHeader();
		this.injectTable(this.header);
		
		if (!options.hideControlBar) {
			this.controlBar = this.createControlBar();
			this.injectTable(this.controlBar);
		}
		
		this.updateTitle();
	},
	createListener: function(){
		CalendarSelect.prototype.createListener.apply(this, arguments);
		
		this.nextHandle = this.handleNext.bindAsEventListener(this);
		this.prevHandle = this.handlePrev.bindAsEventListener(this);														
		this.nextYearHandle = this.handleNextYear.bindAsEventListener(this);
		this.prevYearHandle = this.handlePrevYear.bindAsEventListener(this);														
	},
	updateTitle: function(){
		if (this.controlBar) {
			this.controlBar.titleNode.innerText = this.current.format('MMMM YYYY');
		}
	},
	createControlBar: function(){
		var next = $C("td", { className : "next day"});
		var prev = $C("td", { className : "prev day"});

		if (this.options.showControls) {
			next.innerHTML = "→";
			prev.innerHTML = "←";
			
			next.tabIndex = 0;
			prev.tabIndex = 0;

			next.observe("click", this.nextHandle);
			prev.observe("click", this.prevHandle);
			next.observe("keypress", this.nextHandle);
			prev.observe("keypress", this.prevHandle);
		} 
		
		var nextYear = $C("td", { className : "next year"});
		var prevYear = $C("td", { className : "prev year"});

		if (this.options.showControls && this.options.showYearNavigation) {
			nextYear.innerHTML = "\u23E9";
			prevYear.innerHTML = "\u23E8";
			
			nextYear.tabIndex = 0;
			prevYear.tabIndex = 0;

			nextYear.observe("click", this.nextYearHandle);
			prevYear.observe("click", this.prevYearHandle);
			nextYear.observe("keypress", this.nextYearHandle);
			prevYear.observe("keypress", this.prevYearHandle);
		} 
		
		var main = $C("td", { className : "main" });
		
		var colspan = 3
		colspan += this.options.showWeekNumber ? 1 : 0;
		colspan += !this.options.showYearNavigation ? 2 : 0;
		
		main.setAttribute("colSpan", colspan);
										
		var row = $C("tr", { className : "header"});
		row.titleNode = main;
		
		row.appendChild(prev);
		if (this.options.showYearNavigation) row.appendChild(prevYear);
		row.appendChild(main);
		if (this.options.showYearNavigation) row.appendChild(nextYear);					
		row.appendChild(next);					
		
		return row;
	},
	createHeader: function(){
		var row = $C("tr", { className : "dow"});
		
		if (this.options.showWeekNumber) {
			var week = $C("td");
			week.classList.add('week');
			row.appendChild(week);
		}
		
		moment.weekdays(true).map(i => i.substring(0,1).toUpperCase()).forEach(i => {
			row.appendChild($C("td", { innerHTML : i }));
		});

		return row;
	},

	rebuildTable: function(date){
		this.options.date = moment(date);
		
		this.table.remove();
		this.header.remove();
		if (this.controlBar) {
			this.controlBar.remove();
		}
		
		this.current = date ? moment(date).startOf('month') : moment().startOf('month');
		this.calendarDays = this.buildCalendarDays(this.current);
	
		this.createTable(this.calendarDays.length);
		this.applyBehavior();
		this.applyCalendarDays(this.calendarDays);
		
		this.injectTable(this.header);
		this.injectTable(this.controlBar);
		this.updateTitle();
	},

	update: function(date) {
		this.rebuildTable(date);
	},

	getActive: function() {
		return this.options.active;	
	},
	setActive: function(d, r) {
		this.options.active = d;
		
		if (this.options.active instanceof Array) {
			this.rebuildTable(r ? d[1] : this.options.date); 
		} else {
			this.rebuildTable(r ? d : this.options.date);
		}
	},

	handleNext: function(e){
		if (e.type == 'keypress' && e.key != 'Enter') return;
		e.stopPropagation();
		this.rebuildTable(moment(this.current).add(1, 'months').toDate());
		this.table.querySelector('.header td.next.day').focus();
	},
	handlePrev: function(e){
		if (e.type == 'keypress' && e.key != 'Enter') return;
		e.stopPropagation();
		this.rebuildTable(moment(this.current).subtract(1, 'months').toDate());
		this.table.querySelector('.header td.prev.day').focus();
	},							
	handleNextYear: function(e){
		if (e.type == 'keypress' && e.key != 'Enter') return;
		e.stopPropagation();
		this.rebuildTable(moment(this.current).add(1, 'years').toDate());
		this.table.querySelector('.header td.next.year').focus();
	},
	handlePrevYear: function(e){
		if (e.type == 'keypress' && e.key != 'Enter') return;
		e.stopPropagation();
		this.rebuildTable(moment(this.current).subtract(1, 'years').toDate());
		this.table.querySelector('.header td.prev.year').focus();
	},							

	injectTable: function(ele){
		try{
			var tbody = this.table.down("tbody");
			tbody.insertBefore(ele, tbody.firstChild)
		}
		catch(e){ 
			this.table.insertBefore(ele, this.table.firstChild);
		}
	}
});